import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Navigate } from "react-router-dom";

import { Card, Grid, TextField, Select, MenuItem } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import MediaPickerModal from "Main/Modals/MediaModal";

export default class AddResults extends Component {
  state = {
    result_date: "",
    level_id: "",
    course_id: "",
    img_alt_text: "",

    levels: [],
    courses: [],

    selectedImage: null,
    showMediaModal: false,

    loading: false,
    notification: false,
    message: "",
    notiColor: "success",
    redirect: false,
  };

  componentDidMount() {
    this.getDropdownData();
  }

  // ✅ DROPDOWNS
  getDropdownData = async () => {
    try {
      const [levels, courses] = await Promise.all([
        axios.post(Constants.getUrls.getAllLevels, { page: 1, limit: 100 }),
        axios.post(Constants.getUrls.getAllCourses, { page: 1, limit: 100 }),
      ]);

      this.setState({
        levels: levels.data.data.rows || [],
        courses: courses.data.data.rows || [],
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // ✅ CREATE RESULT
  handleSubmit = async (e) => {
    e.preventDefault();

    const { result_date, level_id, course_id, selectedImage, img_alt_text } =
      this.state;

    if (!result_date || !level_id || !course_id || !selectedImage) {
      return this.setState({
        notification: true,
        message: "All fields are required!",
        notiColor: "warning",
      });
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const payload = {
      result_date,
      level_id,
      course_id,
      image_id: selectedImage.id,
      role_id: 1, // ✅ fixed
      img_alt_text,
    };

    this.setState({ loading: true });

    try {
      const resp = await axios.post(Constants.postUrls.addNewResult, payload);

      this.setState({
        notification: true,
        message: resp.data.message || "Result created!",
        notiColor: "success",
        loading: false,
      });

      setTimeout(() => {
        this.setState({ redirect: true });
      }, 1500);
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong!",
        notiColor: "warning",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) return <Navigate to="/results" />;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card style={{ padding: 20 }}>
            {/* 🔥 HEADER */}
            <MDBox
              mx={2}
              mt={-6}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Add New Result
              </MDTypography>
            </MDBox>

            <form onSubmit={this.handleSubmit}>
              <Grid container spacing={2} mt={1}>
                {/* RESULT DATA */}
                <Grid item sm={6}>
                  <TextField
                    type="date"
                    name="result_date"
                    value={this.state.result_date}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* LEVEL */}
                <Grid item sm={6}>
                  <Select
                    name="level_id"
                    value={this.state.level_id}
                    onChange={this.handleInput}
                    displayEmpty
                    style={{
                      width: "100%",
                      height: "45px",
                      color: "#fff",
                    }}
                  >
                    <MenuItem value="">Select Level</MenuItem>
                    {this.state.levels.map((l) => (
                      <MenuItem key={l.id} value={l.id}>
                        {l.title}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* COURSE */}
                <Grid item sm={6}>
                  <Select
                    name="course_id"
                    value={this.state.course_id}
                    onChange={this.handleInput}
                    displayEmpty
                    style={{
                      width: "100%",
                      height: "45px",
                      color: "#fff",
                    }}
                  >
                    <MenuItem value="">Select Course</MenuItem>
                    {this.state.courses.map((c) => (
                      <MenuItem key={c.id} value={c.id}>
                        {c.course_name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* IMAGE */}
                <Grid item sm={6}>
                  <MDButton
                    variant="contained"
                    onClick={() => this.setState({ showMediaModal: true })}
                  >
                    Select Image
                  </MDButton>

                  {this.state.selectedImage && (
                    <img
                      src={
                        Constants.imageDomain +
                        this.state.selectedImage.image_path
                      }
                      style={{
                        width: 80,
                        height: 80,
                        marginTop: 10,
                        borderRadius: 6,
                      }}
                    />
                  )}
                </Grid>

                {/* ALT TEXT */}
                <Grid item sm={6}>
                  <TextField
                    label="Image Alt Text"
                    name="img_alt_text"
                    value={this.state.img_alt_text}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* SUBMIT */}
                <Grid item sm={12}>
                  <MDButton type="submit" variant="contained" color="info">
                    {this.state.loading ? "Creating..." : "Create Result"}
                  </MDButton>
                </Grid>
              </Grid>
            </form>
          </Card>

          {/* SNACKBAR */}
          <MDSnackbar
            color={this.state.notiColor}
            title="Results"
            content={this.state.message}
            open={this.state.notification}
          />

          {/* MEDIA MODAL */}
          <MediaPickerModal
            visible={this.state.showMediaModal}
            multiple={false}
            onClose={() => this.setState({ showMediaModal: false })}
            onSelect={(images) => {
              this.setState({
                selectedImage: images[0],
                showMediaModal: false,
              });
            }}
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}
